import { render, staticRenderFns } from "./CustomImage.vue?vue&type=template&id=a9cb7604&scoped=true&"
import script from "./CustomImage.vue?vue&type=script&lang=ts&"
export * from "./CustomImage.vue?vue&type=script&lang=ts&"
import style0 from "./CustomImage.vue?vue&type=style&index=0&id=a9cb7604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cb7604",
  null
  
)

export default component.exports